import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import { new_seed as new$ } from "../prng_ffi.mjs";

export { new$ };

/**
 * Creates a new random seed. You can use it when you don't care about
 * having reproducible results and just need to get some values out of a
 * generator using the `random.step` function.
 */
export function random() {
  return new$($int.random(4_294_967_296));
}
